import { jumpWeb, webUrl } from "@/utils/config";
import { getBrowserToken } from "@/utils/auth.js"
const read = {
  state: {
    backclass: "zt_moren",
    searchText: "",
    config: {
      url: "", // 网址，默认使用 window.location.href
      source: "", // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
      title: "", // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
      description: "", // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
      image: "", // 图片, 默认取网页中第一个img标签
      sites: ["wechat", "weibo", "qq"], // 启用的站点
      // disabled: ["google", "facebook", "twitter"], // 禁用的站点
      wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
      wechatQrcodeHelper:
        "<p>微信扫一扫分享</p>",
    },
    isLayout: getBrowserToken() ? false : true,
  },
  getters: {
    threeUserInfo(state) {
      let info = getBrowserToken() || "{}"
      return JSON.parse(info)
    }
  },

  mutations: {
    subjectId_special: (state, id) => {
      state.config.url = webUrl + "/#/special/specialDetail?subjectId=" + id;
    },
    subjectId_book: (state, id) => {
      state.config.url = webUrl + "/#/bookstore/bookstoreDetail?goodsId=" + id;
    },
    SET_BACKCLASS: (state, backclass) => {
      state.backclass = backclass;
    },
    SET_SEARCHTEXT: (state, searchText) => {
      state.searchText = searchText;
    },
    SET_ISLAYOUT: (state, isLayout) => {
      state.isLayout = isLayout;
    },
  },

  actions: {},
};

export default read;
